<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <h1 class="d-inline-block align-middle m-0" data-test-id="page-heading">
      {{ 'ADMINS_TITLE' | translate }}
    </h1>
  </div>

  <button
    appLongOperation
    class="btn btn-primary invite-new-admin-btn"
    type="submit"
    data-test-id="btn-send-signup-invitation"
    (click)="openSendSignupInvitationDialog()"
  >
    {{ 'BTN_INVITE_NEW_ADMIN' | translate }}
  </button>

  <app-admins-list></app-admins-list>
</div>
